import config from './config.json'
import codeCoordinates from './codeCoordinates'
async function getToken(){
    const response = await fetch(config.getAppVersion);
    const data = await response.json();
    const r = data.getAppVersionResult;
    var s="";
    var t_s;
    var t_c;
    var WS1 = r;
    //Extraction du timeUTC en String
    var WS2 = WS1.substring(10, WS1.length);
    //Le convertir en long
    t_s = parseInt(WS2);
    //Le decoder: on obtient la date du serveur
    t_s = t_s - 1334170131052;
    //generer le token
    t_c = t_s + 1225486587123;
    s = makeRString() + t_c + "";
    var atoken=s; //use this token to call getPlacesPersons or GetRoute
    return atoken;
}
function  makeRString(){
    var text = "";
    var possible = "ABCxyz0123456789";

    for (var i = 0; i < 10; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
}
async function requestLocationData(pendingLocation,options){
    let {xCoded , yCoded} = codeCoordinates(pendingLocation.longitude,pendingLocation.latitude);
    let taghtia_request = {"TaghtiaRequest": {
        "token": await getToken(),
        "X": xCoded,
        "Y": yCoded											
            }
        }
    const res = await fetch(config.webService,{
        signal:options.signal.current,
        method:"POST",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(taghtia_request)
    });
    const data = await res.json();
    return data;
}

export {requestLocationData};